<!-- =========================================================================================
    File Name: TableMiscellaneous.vue
    Description: Combine filter,sorter, pagination etc.
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vx-card title="Transaction" id="account-manage-buttons">
    <div>
      <div class="vx-row">
        <div class="vx-col sm:w-9/12 w-full">
          <vx-input-group class="mb-base">
            <vs-input
              v-model="search"
              placeholder="Order Number"
              v-on:keyup.enter="getTransaction()"
            />

            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button color="primary" @click="getTransaction()"
                  >Search</vs-button
                >
              </div>
            </template>
          </vx-input-group>
        </div>
        <div class="vx-col sm:w-3/12 w-full">
          <div class="dropdown-button-container">
            <vs-dropdown>
              <vs-button
                class="btn-drop"
                type="filled"
                icon="expand_more"
                color="success"
              >
                {{
                  status == null
                    ? "Status All"
                    : "Status " + changeStatus(status)
                }}</vs-button
              >
              <vs-dropdown-menu>
                <vs-dropdown-item @click="status = null">All</vs-dropdown-item>
                <vs-dropdown-item @click="status = 0">
                  {{ changeStatus(0) }}
                </vs-dropdown-item>
                <vs-dropdown-item @click="status = 1">
                  {{ changeStatus(1) }}
                </vs-dropdown-item>
                <vs-dropdown-item @click="status = 2">
                  {{ changeStatus(2) }}
                </vs-dropdown-item>
                <vs-dropdown-item @click="status = 3">
                  {{ changeStatus(3) }}
                </vs-dropdown-item>
                <vs-dropdown-item @click="status = 9">
                  {{ changeStatus(9) }}
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </div>
      </div>
      <div v-if="load == 1">
        <br />
        <h5>Load data ....</h5>
      </div>
      <vs-table
        v-model="selected"
        stripe
        :data="transactions"
        id="button-with-loading"
        v-else
      >
        <template slot="thead">
          <vs-th sort-key="title">Code Number</vs-th>
          <vs-th sort-key="title">Unique Code</vs-th>
          <vs-th sort-key="description">Price</vs-th>
          <vs-th sort-key="requirement">Buyer</vs-th>
          <vs-th sort-key="requirement">Seller</vs-th>
          <vs-th sort-key="requirement">Payment Method</vs-th>
          <vs-th sort-key="requirement">Account Number</vs-th>
          <vs-th sort-key="requirement">Bank</vs-th>
          <vs-th sort-key="requirement">Receipt</vs-th>
          <vs-th sort-key="requirement">Status</vs-th>
          <vs-th sort-key="title">Note</vs-th>
          <vs-th sort-key="title">Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ tr.code }}</vs-td>
            <vs-td>{{ tr.unique_code }}</vs-td>
            <vs-td>{{ tr.price }}</vs-td>

            <vs-td>{{ tr.member.nama_panjang }}</vs-td>
            <vs-td>{{ tr.store_transactions[0].store.name }}</vs-td>
            <vs-td>{{ tr.payment_method }}</vs-td>
            <vs-td>{{ tr.account_number }}</vs-td>
            <vs-td>{{ tr.bank.name }}</vs-td>
            <vs-td>
              <vs-button
                v-if="tr.receipt != null"
                icon="icon-download"
                icon-pack="feather"
                @click="getReceipt(tr.id)"
              ></vs-button>
            </vs-td>
            <vs-td>{{ setStatus(tr.status) }}</vs-td>
            <vs-td> {{ tr.note }}</vs-td>
            <vs-td :data="tr.status" v-if="tr.status != 3 && tr.status != 9">
              <vs-dropdown
                vs-trigger-click
                class="ml-auto md:block hidden cursor-pointer"
              >
                <vs-button icon="icon-settings" icon-pack="feather"></vs-button>
                <vs-dropdown-menu class="w-32">
                  <vs-dropdown-item v-if="tr.status < 3">
                    <div
                      @click="verifyTransaction(tr.id)"
                      class="flex items-center"
                    >
                      <span>Verify</span>
                    </div>
                  </vs-dropdown-item>
                  <vs-dropdown-item v-if="tr.status < 2">
                    <div
                      @click="unverifyTransaction(tr.id)"
                      class="flex items-center"
                    >
                      <span>Unverify</span>
                    </div>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <br />
      <template>
        <vs-pagination :total="20" v-model="page" :max="10"></vs-pagination>
      </template>
    </div>
  </vx-card>
</template>
   

<script>
import axios from '../../../axios110'
import Prism from 'vue-prism-component'
import moment from 'moment'
import router from '../../../router'
export default {
  data() {
    return {
      'selected': [],
      'tableList': [
        'vs-th: Component',
        'vs-tr: Component',
        'vs-td: Component',
        'thread: Slot',
        'tbody: Slot',
        'header: Slot'
      ],
      'payments': [],
      'transactions': [],
      'colorAlert': 'primary',
      'titleAlert': 'Alert',
      'activeAlert': false,
      'valueInput': '',
      userAuth: this.$store.state.user,
      'deleteId': null,
      popupActive: false,
      popUpData: [],
      load: 1,
      page: 1,
      limit: 10,
      oldData: [],
      active1: true,
      alert_success: false,
      message_success: '',
      color: 'success',
      search: '',
      status: null,

    }
  },
  watch: {
    page(newValue, oldValue) {
      this.getTransaction()

    },
    status(newValue, oldValue) {
      this.resetPageStatus()


    },


  },
  mounted() {
    this.popupActive = false
    this.getTransaction()

  },
  methods: {
    getReceipt(id) {
      axios.get('ecommerce/web/transaction/receipt/' + id, {})
        .then(res => {
          this.redirect(res.data)
        })
        .catch(error => {
          console.log(error.response)
          this.acceptAlert('warning', 'Sorry', 'Something wrong')
        })
    },
    redirect: function (link, target = '_blank') {
      window.open(link, target);
    },
    resetPageStatus() {

      this.resetPage()
    },
    resetPage() {
      this.page = 1
      this.getTransaction()
    },
    verifyTransaction(id) {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#account-manage-buttons",
        scale: 0.45
      })
      axios.put('ecommerce/web/transaction/verify/' + id, {})
        .then(res => {

          console.log(res)
          this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
          this.acceptAlert('success', 'Congrats', 'Success verify transaction ')
          this.getTransaction()
        })
        .catch(error => {
          console.log(error.response)
          this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
          this.acceptAlert('warning', 'Sorry', 'Something wrong')
        })


    },
    unverifyTransaction(id) {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#account-manage-buttons",
        scale: 0.45
      })
      axios.put('ecommerce/web/transaction/unverify/' + id, {})
        .then(res => {

          console.log(res)
          this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
          this.acceptAlert('success', 'Congrats', 'Success unverify transaction ')
          this.getTransaction()
        })
        .catch(error => {
          console.log(error.response)
          this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
          this.acceptAlert('warning', 'Sorry', 'Something wrong')
        })


    },

    changeStatus(status) {
      if (status == 0) {
        return 'New'
      }
      if (status == 1) {
        return 'Waiting'
      }
      if (status == 2) {
        return 'Unverified'
      }
      if (status == 3) {
        return 'Verified'
      }
      if (status == 9) {
        return 'Cancel'
      }

    },
    getTransaction() {
      this.load = 1
      this.transactions = []
      let statusParam = this.status == null ? '' : '&status=' + this.status
      let searchParam = this.search ? '&order_number=' + this.search : ''
      axios.get(`/ecommerce/web/transaction?limit=` + this.limit + '&page=' + this.page + searchParam + statusParam, {})
        .then(res => {

          console.log(res)
          this.transactions = res.data
          this.load = 0
        })
        .catch(error => {
          console.log(error.response)
          this.load = 0
        })

    },
    setStatus(status) {
      if (status == 0) {
        return 'New'
      }
      if (status == 1) {
        return 'Waiting'
      }
      if (status == 2) {
        return 'Unverified'
      }
      if (status == 3) {
        return 'Verified'
      }
      if (status == 9) {
        return 'Cancel'
      }

    },

    format_date(value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD')
      }
    },
    limitChar(str) {
      var output = ''
      if (str.length > 100) {
        str = str.substring(0, 100)
        output = str + '...'
      } else {
        output = str
      }
      return output
    },



    handleSelected(tr) {
      this.$router.push(`/payment/${tr.id}/applicant`)
    },
    acceptAlert(color, title, message) {

      this.$vs.notify({
        color,
        title,
        text: message
      })

    },

  },
  components: {
    Prism
  }
}
</script>
